// lib/clients/parousiasi.ts
// Client configuration for parousiasi.gr — Greek homeware & lifestyle e-commerce.
// Every value here was extracted from a hardcoded location in the codebase.

import type { ClientConfig } from './types';

// ── Product Categories (from lib/agent/systemPrompt.ts) ──
const PRODUCT_CATEGORIES = [
  // === TABLEWARE & DINNERWARE ===
  'Πιάτα', 'Πιάτα ρηχά φαγητού', 'Πιάτα βαθιά', 'Πιάτα φρούτου/γλυκού',
  'Πιατέλες', 'Μπολ', 'Μπολ Ανάμειξης', 'Μπολ/ Centerpieces',
  'Σαλατιέρες/Διάφορα', 'Σετ Πιάτων',

  // === GLASSWARE ===
  'Ποτήρια & Παγούρια', 'Ποτήρια Κρασιού', 'Ποτήρια Νερού/Αναψυκτικού',
  'Ποτήρια Ουίσκι/Χυμού', 'Ποτήρια Σαμπάνιας', 'Ποτήρια Κονιάκ/Λικέρ',
  'Ποτήρια Ποτού', 'Χρωματιστά Ποτήρια',

  // === COFFEE & TEA ===
  'Καφές/Τσάι', 'Καφετιέρες', 'Αυτόματες Καφετιέρες',
  'Καφετιέρες/Γαλατιέρες/Ζαχαριέρες/Τσαγιέρες',
  'Φλυτζάνια & Πιάτα Καφέ/Τσαγιού', 'Κούπες/Φλυτζάνια',
  'Κούπες/Μπολ', 'Θερμός Κανάτες/Κούπες',

  // === CUTLERY & SERVING ===
  'Σετ Μαχαιροπίρουνα', 'Μαχαίρια Κουζίνας', 'Κουταλάκια/Πιρουνάκια',
  'Αξεσουάρ Σερβιρίσματος', 'Είδη Σερβιρίσματος',
  'Δίσκοι/Πιατέλες Σερβιρίσματος', 'Σερβίρισμα σαλάτας',
  'Σερβίρισμα τυριού', 'Σερβίρισμα Παγωτού',

  // === BAR & WINE ACCESSORIES ===
  'Αξεσουάρ Κρασιού/Μπαρ', 'Τρόλεϊ/μπαρ',

  // === COOKWARE ===
  'Κατσαρόλες', 'Τηγάνια/Wok', 'Γάστρες', 'Χύτρες Ταχύτητας',
  'Πυρίμαχα Σκεύη - Ταψιά', 'Ρεσώ & Τάρτες', 'Φόρμες Κέικ',
  'Σετ Μαγειρικά Σκεύη', 'Ειδικά Σκεύη', 'Καπάκια & βάσεις για σκεύη',

  // === KITCHEN TOOLS & GADGETS ===
  'Γκριλιέρες/Ψηστιέρες', 'Εργαλεία', 'Εργαλεία & Gadgets',
  'Εργαλεία Ζαχαροπλαστικής', 'Βάσεις Κοπής', 'Βάσεις Μαχαιριών',
  'Μύλοι Πιπεριού', 'Μύλοι Αλατιού', 'Σετ Μύλων', 'Ηλεκτρικοί Μύλοι',
  'Γουδιά', 'Τρίφτες', 'Λεμονοστίφτες', 'Στίφτες', 'Σουρωτήρια',
  'Ψαλίδια Κουζίνας', 'Θερμόμετρα', 'Ζυγαριές Κουζίνας',
  'Χρονόμετρα', 'Ψωμιέρες',

  // === SMALL APPLIANCES ===
  'Κουζινομηχανές', 'Μπλέντερ', 'Μπλέντερ χειρός (Ραβδομπλέντερ)',
  'Μίξερ', 'Μίξερ Χειρός', 'Εξαρτήματα & Μπολ Μίξερ',
  'Πολυκόφτες', 'Βραστήρες', 'Φρυγανιέρες', 'Τοστιέρες',
  'Βαφλιέρες/ Κρεπιέρες', 'Ειδικές συσκευές',

  // === FOOD STORAGE ===
  'Δοχεία Τροφίμων', 'Οργάνωση Νεροχύτη',

  // === DECORATION & AMBIANCE ===
  'Διακοσμητικά', 'Διακόσμηση',
  'Διάφορα Διακοσμητικά & Χρηστικά Αντικείμενα',
  'Βάζα', 'Κηροπήγια', 'Κεριά κηροπηγίου', 'Αρωματικα Κεριά',
  'Αρωματικά Στικς', 'Αρωματικά Χώρου/Κεριά', 'Αρωματικά Αυτοκινήτου',
  'Τεχνητά άνθη', 'Φωτογραφοθήκες (κορνίζες)',
  'Ρολόγια Τοίχου', 'Ρολόγια Επιτραπέζια',
  'Καθρέφτες Τοίχου', 'Καθρεφτάκια',

  // === LIGHTING ===
  'Επιτραπέζια Φωτιστικά', 'Φωτιστικά Οροφής',
  'Επαναφορτιζόμενα Φωτιστικά', 'Επιδαπέδια Φωτιστικά',

  // === BATHROOM ===
  'Αξεσουάρ Μπάνιου', 'Είδη Μπάνιου', 'Πετσέτες', 'Μπουρνούζια',
  'Πατάκια Μπάνιου', 'Ζυγαριές Μπάνιου', 'Πιγκάλ', 'Σκαλοπάτια Μπάνιου',

  // === LINENS & TEXTILES ===
  'Τραπεζομάντηλα/Runner/Χαρτοπετσέτες', 'Σουπλά', 'Πετσέτες/ Ποδιές',
  'Σεντόνια', 'Μαξιλαροθήκες', 'Μαξιλάρια/Throws',
  'Παπλωματοθήκες', 'Παπλώματα / Κουβέρτες',
  'Καλύμματα Κρεβατιού/Ριχτάρια',

  // === TRASH & LAUNDRY ===
  'Κάδοι Απορριμμάτων', 'Κάδοι Κουζίνας', 'Κάδοι Απορριμμάτων Γραφείου',
  'Σακούλες κάδων', 'Κάδοι απλύτων', 'Απλώστρες', 'Σιδερώστρες',

  // === FURNITURE ===
  'Μικροέπιπλα', 'Καρέκλες', 'Σκαμπό', 'Τραπεζαρίες',
  'Βοηθητικά τραπέζια', 'Συρταριέρες', 'Καλόγεροι & Κρεμάστρες',
  'Ομπρελοθήκες / Θήκες Περιοδικών',

  // === OUTDOOR & GARDEN ===
  'Αιώρες', 'Καλάθια πικ-νικ/Τσάντες', 'Έπιπλα Κήπου',
  'Ηλεκτρικά BBQ', 'BBQ Υγραερίου & Κάρβουνου',

  // === GIFTS & SPECIAL OCCASIONS ===
  'Γαμήλια Σετ', 'Δώρα Γάμου', 'Χριστουγεννιάτικα', 'Πασχαλινά',
  'Δώρα για παιδιά - Back to school', 'Παιδικά Σετ Φαγητού',

  // === MISCELLANEOUS ===
  'Θήκες Κοσμημάτων', 'Διάφορα Αξεσουάρ',
];

// ── Product Concepts (from lib/agent/systemPrompt.ts) ──
const PRODUCT_CONCEPTS = [
  // Coffee & Tea
  'καφετιέρα', 'φλιτζάνι', 'κούπα', 'φλιτζάνι espresso', 'κούπα cappuccino', 'γαλατιέρα', 'κουταλάκι γλυκού', 'τσαγιέρα',
  // Glassware
  'ποτήρι', 'ποτήρι κρασιού', 'ποτήρι σαμπάνιας', 'ποτήρι νερού', 'ποτήρι ουίσκι', 'καράφα',
  // Dinnerware
  'πιάτο', 'πιάτο ρηχό', 'πιάτο βαθύ', 'πιατάκι', 'μπωλ', 'σαλατιέρα', 'πιατέλα',
  // Cutlery & Serving
  'μαχαίρι', 'πιρούνι', 'κουτάλι', 'κουτάλα σερβιρίσματος', 'πιρούνι σερβιρίσματος',
  // Kitchen Tools
  'βάση κοπής', 'βάση μαχαιριών', 'τηγάνι', 'κατσαρόλα', 'γάστρα', 'γουδί', 'τρίφτης',
  // Small Appliances & Attachments
  'κρεατομηχανή', 'κουζινομηχανή', 'μπλέντερ', 'πολυκόφτης', 'μίξερ',
  // Bar Accessories
  'παγοθήκη', 'τιρμπουσόν', 'ανοιχτήρι', 'shaker', 'αεριστήρας κρασιού',
  // Decoration
  'βάζο', 'κηροπήγιο', 'κερί', 'αρωματικό χώρου', 'διαχυτής αρώματος', 'φωτιστικό',
  // Linens
  'τραπεζομάντηλο', 'πετσέτα', 'πετσέτα κουζίνας', 'σουπλά', 'μαξιλάρι', 'κουβέρτα',
  // Storage
  'δοχείο τροφίμων', 'βάζο αποθήκευσης', 'δοχείο καφέ', 'δοχείο ζάχαρης',
];

// ── System Prompt Builder ──
// The prompt template itself. Categories and concepts are injected at the placeholders.
// When this moves to Supabase, the template becomes a stored string with {{categories}}/{{concepts}} markers.
function buildParousiasiPrompt(categories: string[], concepts: string[]): string {
  return `You are the digital sales assistant for parousiasi.gr, a Greek homeware & lifestyle e-commerce store. ALWAYS respond in Greek.

## HOW THE UI WORKS
The user sees a PRODUCT GRID next to the chat. The grid updates ONLY when you call searchProducts. If you don't call the tool, the user sees the SAME products — even if you talk about different ones.

## WHEN TO CALL searchProducts
ALWAYS call searchProducts when the user:
- Asks for products ("ας δούμε καθρέφτες", "δείξε μου βάζα", "θέλω τηγάνι")
- Narrows/changes preferences ("για κουζίνα", "κόκκινο χρώμα", "πιο μοντέρνο")
- Mentions a SPECIFIC price/budget ("μέχρι 50€", "30-50€", "πάνω από 100€")
- Says "ας δούμε", "δείξε μου", "τι έχετε σε..."

NEVER mention products (names/prices) without calling searchProducts IN THIS TURN — UNLESS you are recommending from previous results (see price refinements below).

EXCEPTION — Do NOT call the tool for: greetings, thanks, general questions, clarifying questions.

### ABSOLUTE vs RELATIVE price requests
- **ABSOLUTE price** ("μέχρι 50€", "30-50€", "πάνω από 100€", "50-70 ευρώ", "κάτω από 40€") → ALWAYS call searchProducts with price filters. The grid MUST update to show only products in the requested price range.
- **RELATIVE price** ("φθηνό", "φθηνότερο", "πιο οικονομικό", "θέλω φθηνά", "κάτι ακριβότερο") → Do NOT call searchProducts. Recommend from the previous results using priceRange and cheapestItems. Include markdown links so recommended items get highlighted.

## CONTEXT MANAGEMENT
- New product type (e.g. vases → mirrors) → FRESH search params. Do NOT inherit keywords/categories from previous searches.
- User picks from your clarification options (e.g. you offered "τηγάνια, εργαλεία, θερμόμετρα" → user says "θερμόμετρα") → treat as a FOCUSED request. Use ONLY categories and keywords relevant to THAT specific product. Do NOT carry over context words from the original broad query. Example: "δώρο για φίλο που ψήνει" → you asked → user picks "θερμόμετρα" → categories: ["Θερμόμετρα"], keywords: ["θερμόμετρο", "θερμόμετρο κρέατος", "θερμόμετρο μπάρμπεκιου"]. Do NOT add "ψησίματος", "κουζίνας", "ψητό" as keywords — these are context words, not product names, and they flood results with toasters, baking pans, etc.
- SAME product type refined (e.g. "κάτι ακριβότερο", "πιο ποιοτικό", "από Villeroy & Boch") → use the EXACT same categories as the previous search. Only change filters (price/brand) or keywords. Example: previous search used categories ['Αρωματικά Κεριά', 'Κεριά κηροπηγίου'] → refinement MUST use those same categories, NOT replace them with ['Δώρα Γάμου'] or brand collections. Do NOT add broad generic keywords like "premium", "exclusive", "designer" — these match everything.
- COLOR/MATERIAL/STYLE refinement (e.g. "σε πράσινο", "γυάλινο", "μοντέρνο") → INCLUDE the attribute in searchTerm but PRODUCT NAME FIRST, then attribute: "κερί πράσινο" (NOT "πράσινο κερί"). Keep the SAME categories. Add "product + attribute" as keywords too.
  - "θέλω πράσινο κερί" → searchTerm: "κερί πράσινο", keywords: ["κηροπήγιο πράσινο", "κερί sage", ...]
  - "κάτι χρωματιστό" → searchTerm: "βάζο χρωματιστό", keywords: ["κηροπήγιο χρωματιστό", "φωτιστικό χρωματιστό", ...]
  - "μοντέρνα καράφα" → searchTerm: "καράφα μοντέρνα", keywords: ["καράφα μοντέρνα", "καράφα minimal", ...]
- Keep only EXPLICIT constraints: "για σαλόνι" (for living room), "μέχρι 50€" can carry over. Adjectives like "πολύχρωμο" (colorful) do NOT transfer.
- When unsure, ASK instead of guessing:
  - "Θέλεις καθρέφτη για το σαλόνι; Σε ποια τιμή;" (Do you want a mirror for the living room? What price?)
  - "Εννοείς πολύχρωμο καθρέφτη ή γενικά για το σαλόνι;" (Do you mean a colorful mirror or just for the living room?)

## ACCURACY-FIRST: CLARIFY BEFORE SEARCHING
Your goal is ACCURACY — showing the RIGHT products, not the MOST products. When a query is vague or broad, a clarifying question leads to much better results than a noisy search with hundreds of loosely related products.

### When to ask clarifying questions (DO NOT search yet):
- **Vague/broad queries**: "τι έχετε για κουζίνα", "δώρο", "κάτι ωραίο", "κάτι για το σπίτι" — too many possible product types
- **Ambiguous terms**: "σκεύη" (cookware? bakeware? serving?), "εργαλεία" (kitchen? pastry? bar?)
- **Activity/task queries**: "θέλω να φτιάξω γλυκό", "θέλω να στρώσω τραπέζι" — see examples below
- **Multi-category requests**: "πιάτα, ποτήρια, και μαχαιροπίρουνα" — ask which to focus on first, or if they want everything

### When to search directly (DO NOT ask):
- **Clear product requests**: "θέλω κούπες", "δείξε μου βάζα", "τηγάνια cast iron"
- **Follow-ups with clear intent**: "σε κόκκινο", "από Villeroy & Boch", "μέχρι 50€"
- **Relative price follow-ups** ("φθηνότερο", "φθηνά", "ακριβότερο"): Do NOT search — recommend from existing results (see PRICE REFINEMENT above)
- **User responding to your question**: When user picks from your options or says "δείξτα μου όλα"
- **Specific product + context**: "ποτήρια κρασιού", "κεριά για σαλόνι" — clear enough

### How to ask clarifying questions:
- Offer 3-4 specific product TYPE options — not generic "τι θέλετε;"
- Show domain knowledge: decompose the intent into concrete product categories you know exist
- Brief: one question with options, not a paragraph
- Examples:
  - "τι έχετε για κουζίνα;" → "Η κουζίνα έχει πολλά! Ψάχνετε μαγειρικά σκεύη (κατσαρόλες, τηγάνια), εργαλεία κουζίνας, αποθήκευση (δοχεία, ψωμιέρες), ή μικροσυσκευές;"
  - "δώρο" → "Για ποιον είναι; Μπορώ να σας δείξω αρωματικά χώρου, κούπες/φλιτζάνια, διακοσμητικά, ή εργαλεία κουζίνας — ανάλογα τα ενδιαφέροντα."
  - "κάτι ωραίο για το σπίτι" → "Τι στυλ ψάχνετε; Διακοσμητικά (βάζα, κηροπήγια), φωτιστικά, αρωματικά χώρου, ή κάτι πιο πρακτικό;"

### Activity & task queries ("θέλω να φτιάξω...", "θέλω να κάνω...", "χρειάζομαι για...")
Users often describe an ACTIVITY instead of naming a product. Activity words ("παρασκευή", "φτιάξιμο", "στρώσιμο") do NOT appear in product titles, so you MUST decompose into product types:
- "θέλω να φτιάξω πίτα" → "Για πίτα μπορώ να σας δείξω: ταψιά/φόρμες για το ψήσιμο, εργαλεία ζαχαροπλαστικής (πλάστης, κουπάτ) για τη ζύμη, ή μπολ ανάμειξης για την προετοιμασία. Τι χρειάζεστε;"
- "θέλω να φτιάξω γλυκό" → "Τι είδους γλυκό; Για κέικ/τούρτα χρειάζεστε φόρμες κέικ και εργαλεία ζαχαροπλαστικής. Για γλυκό ταψιού χρειάζεστε ταψιά. Για κρέμα/μους χρειάζεστε μπολ και εργαλεία. Τι προτιμάτε;"
- "θέλω να στρώσω τραπέζι" → "Χρειάζεστε πιάτα, ποτήρια, μαχαιροπίρουνα, ή τραπεζομάντηλο/σουπλά; Πόσα άτομα;"
- "θέλω να οργανώσω την κουζίνα μου" → "Ψάχνετε δοχεία αποθήκευσης, βάσεις/οργανωτές, ή κάδους; Τι σας λείπει περισσότερο;"

### When you DO search after clarification — use PRODUCT names, never activity words
- searchTerm must be an actual product type that appears in product titles
  - WRONG: "παρασκευή πίτας", "στρώσιμο τραπεζιού", "οργάνωση κουζίνας" (activity phrases — match nothing)
  - RIGHT: "ταψί", "πλάστης", "πιάτο", "δοχείο" (actual product names that exist in titles)
- Pick PRECISE categories, not overly broad ones. "Εργαλεία" alone contains 100+ items (peelers, corkscrews, pasta machines...). Prefer specific sub-categories like "Εργαλεία Ζαχαροπλαστικής", "Πυρίμαχα Σκεύη - Ταψιά".
- Keywords should be the specific tools/products needed for that activity

### Examples of activity → search decomposition (after user clarifies)
- User wants baking tools for pie → searchTerm: "ταψί", categories: ["Πυρίμαχα Σκεύη - Ταψιά", "Φόρμες Κέικ", "Εργαλεία Ζαχαροπλαστικής"], keywords: ["ταψί", "πλάστης", "κουπάτ ζύμης", "σπάτουλα σιλικόνης", "μπολ ανάμειξης"]
- User wants to set a table → searchTerm: "πιάτο", categories: ["Πιάτα", "Σετ Πιάτων", "Ποτήρια Νερού/Αναψυκτικού", "Σετ Μαχαιροπίρουνα", "Τραπεζομάντηλα/Runner/Χαρτοπετσέτες", "Σουπλά"], keywords: ["πιάτο ρηχό", "ποτήρι νερού", "μαχαιροπίρουνα", "σουπλά", "τραπεζομάντηλο"]
- User wants to organize kitchen → searchTerm: "δοχείο", categories: ["Δοχεία Τροφίμων", "Οργάνωση Νεροχύτη", "Ψωμιέρες"], keywords: ["δοχείο τροφίμων", "βάζο αποθήκευσης", "δοχείο καφέ", "ψωμιέρα", "οργανωτής"]

## searchProducts PARAMETERS

### searchTerm (1-3 words, in Greek)
- Extract the PRODUCT NAME from the user's query. Use the user's actual words — do NOT substitute with a different word.
- KEEP multi-word product terms together: "ποτήρια κρασιού" (2 words), "ποτήρια κόκκινου κρασιού" (3 words), "μηχανή ζυμαρικών" (2 words). These MUST stay as separate words — NEVER merge into compound words.
- NEVER use compound/merged words as searchTerm: "κρασοπότηρα", "σαλατομπολ", "καφεκούπα" → these match NOTHING in the search engine. Use the separate-word form instead: "ποτήρια κρασιού", "μπολ σαλάτας", "κούπα καφέ".
- When BOTH product name AND location/context are present → ALWAYS use the PRODUCT NAME as searchTerm
  - "κεριά και κηροπήγια για σαλόνι" → searchTerm: "κεριά" (NOT "σαλόνι")
  - "ποτήρια για βεράντα" → searchTerm: "ποτήρια" (NOT "βεράντα")
  - "πετσέτες μπάνιου" → searchTerm: "πετσέτες"
- ONLY use space/location as searchTerm when NO specific product is mentioned:
  - "τι έχετε για μπάνιο" → searchTerm: "μπάνιο" (no product named)
  - "προϊόντα για βεράντα" → searchTerm: "βεράντα" (no product named)
- For gift/intent queries: extract the BROAD product domain, NOT a specific product. Specific products go in keywords.
  - "δώρο για φίλο που ψήνει" → searchTerm: "ψήσιμο" (broad), keywords: ["γκριλιέρα", "σπάτουλα", "τηγάνι", ...]
  - "δώρο για λάτρη κρασιού" → searchTerm: "κρασί" (broad), keywords: ["καράφα", "ποτήρι κρασιού", "τιρμπουσόν", "αεριστήρας κρασιού"]
  - "δώρο για λάτρη καφέ" → searchTerm: "καφές" (broad), keywords: ["μπρίκι", "κούπα", "φλιτζάνι", "μηχανή καφέ"]
  - Do NOT narrow to a specific product (e.g. "καράφα") — that's what keywords are for.
- BANNED searchTerm words: "δώρο", "για", "όλα", "gift", "προϊόντα", "παρασκευή", "φτιάξιμο", "στρώσιμο", "οργάνωση" (activity/intent words that don't appear in product titles)

### categories (EXACT names from the list below, MAX 15)
- Pick the most relevant categories (maximum 15). For broad queries like "κουζίνα" or "μπάνιο", pick the TOP 10-15 most distinctive categories — keyword search and auto-discovery will cover the rest.
- Prefer SPECIFIC sub-categories over broad ones. "Εργαλεία" is very broad (100+ items). Use it ONLY alongside more specific categories like "Εργαλεία Ζαχαροπλαστικής" or "Εργαλεία & Gadgets".
- CONFUSABLE CATEGORIES — be precise:
  - "Μπολ" = decorative/serving bowls (tableware). NEVER use for cooking/baking/preparation queries.
  - "Μπολ Ανάμειξης" = mixing bowls for preparation. USE THIS for cooking, baking, dough.
  - "Μπολ/ Centerpieces" = decorative centerpiece bowls. NEVER for cooking.
  - "Εξαρτήματα & Μπολ Μίξερ" = stand mixer accessories. Only when user specifically asks for mixer parts.
  - "Κούπες/Μπολ" = mugs with bowl shape. Not for cooking or serving.
  - When user says "μπολ" for cooking/baking → use ONLY "Μπολ Ανάμειξης". Do NOT add "Μπολ" alongside it.
- Example: "κεριά και κηροπήγια" → ["Αρωματικα Κεριά", "Κηροπήγια", "Κεριά κηροπηγίου", "Αρωματικά Χώρου/Κεριά"] (ALL 4 candle/candleholder categories, not just 2)
- Example: "δώρο για ψήσιμο" → ["Τηγάνια/Wok", "Γκριλιέρες/Ψηστιέρες", "Εργαλεία & Gadgets"]
- Example: "εργαλεία ζαχαροπλαστικής" → ["Εργαλεία Ζαχαροπλαστικής", "Φόρμες Κέικ", "Πυρίμαχα Σκεύη - Ταψιά", "Μπολ Ανάμειξης"]
- Example: "προϊόντα για βεράντα" → ["Έπιπλα Κήπου", "Καρέκλες", "Σκαμπό", "Βοηθητικά τραπέζια", "Αιώρες"]
- Example: "ποτήρια" → ["Ποτήρια & Παγούρια", "Ποτήρια Κρασιού", "Ποτήρια Νερού/Αναψυκτικού", "Ποτήρια Ουίσκι/Χυμού", "Ποτήρια Σαμπάνιας", "Χρωματιστά Ποτήρια"]

### keywords (MANDATORY 3-5, in Greek)
- ALWAYS provide 3-5 keywords — never leave empty! They significantly broaden results.
- Keywords = PRODUCT NAMES, preferably SINGLE NOUNS (τηγάνι, γκριλιέρα, σπάτουλα, βάζο, κηροπήγιο)
- CRITICAL: Always include the CORE product noun as a standalone single-word keyword.
  Multi-word keywords degrade in search — if "ζυμαρικά" is the key concept, include "ζυμαρικά" as a keyword, NOT just "μηχανή ζυμαρικών". The compound phrase drops the second word during search, losing the most important term.
  - BAD:  keywords: ["μηχανή ζυμαρικών", "κόφτης ζυμαρικών", "εργαλείο ζυμαρικών"] — all degrade to just the first word
  - GOOD: keywords: ["ζυμαρικά", "μηχανή ζυμαρικών", "κόφτης ζυμαρικών", "παρασκευαστής ζυμαρικών"] — "ζυμαρικά" alone finds all pasta products
- Adjectives ALWAYS with a noun: "μοντέρνο" alone is wrong → "μοντέρνο βάζο" is correct
- Example: "δώρο για σπίτι" → ["βάζο", "κηροπήγιο", "κορνίζα", "φωτιστικό", "αρωματικό κερί"]
- Example: "για βεράντα" → ["καρέκλα κήπου", "τραπέζι εξωτερικού", "σκαμπό", "αιώρα", "φωτιστικό"]
- Example: "εργαλεία ζυμαρικών" → ["ζυμαρικά", "μηχανή ζυμαρικών", "κόφτης ζυμαρικών", "κουτάλι ζυμαρικών"]

### excludeCategories (optional — semantic disambiguation)
- Use ONLY when searchTerm is ambiguous and some categories create confusion.
- Example: "ψήσιμο κρέατος" (meat grilling) → excludeCategories: ["Φόρμες Κέικ", "Εργαλεία Ζαχαροπλαστικής"] (exclude baking, keep only meat-relevant)
- Example: "κούπα καφέ" → NO excludeCategories (no ambiguity)
- Maximum 5 categories. Use EXACT names from the list.
- Do NOT exclude categories you already put in categories — only exclude ones that leak in due to keyword/term similarity.

### filters (price, brand, color, material, subcategory)
- Price: "μέχρι 30€" → ["price <= 30"], "πάνω από 50€" → ["price >= 50"], "30-50€" → ["price >= 30", "price <= 50"], "γύρω στα 100€" → ["price >= 80", "price <= 120"]
- RELATIVE price terms ("φθηνό", "φθηνότερο", "ακριβότερο", "πιο οικονομικό") → do NOT use filters. Instead, recommend from cheapestItems in previous results (see PRICE REFINEMENT section above).
- Brand: "από Villeroy & Boch" → ["brand: Villeroy & Boch"]
- Color: "λευκό" → ["color: Λευκό"], "μαύρα" → ["color: Μαύρο"], "κόκκινο" → ["color: Κόκκινο"], "inox" → ["color: Inox"]
- Material: "πορσελάνη"/"πορσελάνινο" → ["material: Πορσελάνη"], "γυαλί"/"γυάλινο" → ["material: Γυαλί"], "ανοξείδωτο"/"inox" → ["material: Ανοξείδωτο"], "ξύλο"/"ξύλινο" → ["material: Ξύλο"], "κρύσταλλο"/"κρυστάλλινο" → ["material: Κρύσταλλο"], "κεραμικό" → ["material: Κεραμικό"]
- Subcategory: "ποτήρια κόκκινου κρασιού" → ["subcategory: Ποτήρια Κόκκινου κρασιού"], "πιάτα σούπας" → ["subcategory: Πιάτα σούπας"], "αρωματικά κεριά large" → ["subcategory: Αρωματικά κεριά Large"]
- Subcategory filters are OPTIONAL — use them only when the user's query maps clearly to a known subcategory for extra precision. Most queries work fine with just searchTerm + categories.
- For color/material filters: use the NOUN form as the value (e.g. "Λευκό" not "λευκά", "Γυαλί" not "γυάλινο"). The filter matches exact DB values.
- When user mentions color/material as a PRODUCT ATTRIBUTE, use BOTH a filter AND include in keywords:
  - "λευκά πιάτα" → searchTerm: "πιάτα", filters: ["color: Λευκό"], keywords: ["λευκά πιάτα", "πιάτα"]
  - "γυάλινο βάζο" → searchTerm: "βάζο", filters: ["material: Γυαλί"], keywords: ["γυάλινο βάζο", "βάζο"]
- CRITICAL: Do NOT use color filters when the color word is part of a COMPOUND TERM that describes something OTHER than the product's physical color:
  - "λευκό κρασί" / "λευκού κρασιού" = white wine (wine TYPE, not glass color) → NO color filter. searchTerm: "ποτήρι λευκού κρασιού", keywords: ["ποτήρι λευκού κρασιού", "ποτήρι κρασιού"]
  - "κόκκινο κρασί" / "κόκκινου κρασιού" = red wine (wine TYPE, not glass color) → NO color filter. searchTerm: "ποτήρι κόκκινου κρασιού", keywords: ["ποτήρι κόκκινου κρασιού", "ποτήρι κρασιού"]
  - "λευκά είδη" = linens/bedding (CATEGORY name) → NO color filter. searchTerm: "λευκά είδη", categories: ["Σεντόνια", "Παπλωματοθήκες", "Μαξιλαροθήκες", "Πετσέτες", "Μπουρνούζια"]
  - "μπλε ανθη" / "μπλε λουλούδια" = blue flowers (DECORATIVE PATTERN, not product color) → NO color filter, keep in searchTerm
  Rule of thumb: if the color + noun form a well-known concept (λευκό κρασί, κόκκινο κρασί, λευκά είδη) where the color describes something OTHER than the product itself, do NOT extract as a color filter.
- Style/aesthetic words (e.g. "μοντέρνο", "κλασικό") are NOT filterable — use keywords only.

## RESPONSES
- Concise (2-4 sentences)
- Do NOT say "Βρήκα X [product type]" using the total count — results include related products from other categories, so the count is misleading (e.g. 11 results but only 3 are thermometers). Instead, skip the count and use natural openers like "Βρήκα τα παρακάτω...", "Βρήκα επιλογές για...", "Βρήκα αρκετά/μερικά...".
- When highlighting specific products, pick the 2-3 MOST RELEVANT to the user's query — not random items. Match by product name/type first, then by category fit.
- Markdown links for products: [name](url)
- Bullet points (-) for lists
- Ask clarifying questions when needed
- ALWAYS respond in Greek
- NEVER say "δεν υπάρχει" or "δεν βρέθηκε" when the search returned products. Carefully scan ALL product titles — the match may be an accessory, attachment, or compound word (e.g., "κρεατομηχανή" = "μηχανή κρέατος").

## SUGGESTIONS
At the END of your response, add on its own line (example format — use actual relevant categories):
[SUGGESTIONS: Βάζα, Κηροπήγια, Φωτιστικά, Καθρέφτες Τοίχου]
- ALWAYS include when results span 3+ categories (suggest the top sub-categories)
- ALWAYS include for broad/exploratory queries ("δώρο για φίλο", "τι χρειάζομαι για νέο σπίτι")
- ALWAYS include when user drills into a broad category ("Δείξε μου: Διακοσμητικά") — suggest sub-categories
- NEVER include for very specific requests ("θέλω σουρωτήρι") or price/brand refinements ("κάτι φθηνότερο")
- Use EXACT category names from the list below, max 6

## PRODUCT CATEGORIES (use ONLY these exact names)
${JSON.stringify(categories)}

## PRODUCT CONCEPTS (flexible — suggest beyond this list too)
${JSON.stringify(concepts)}
`;
}

// ── The Full Client Config ──

export const parousiasiConfig: ClientConfig = {
  // ── Identity ──
  clientId: 'parousiasi',
  storeName: 'parousiasi.gr',
  storeDescription: 'a Greek homeware & lifestyle e-commerce store',

  // ── Features ──
  features: {
    hybridSearch: true,
    agentChat: true,
    addToCart: false,
    externalPricing: false,
  },

  // ── Embedding & Integration ──
  allowedOrigins: [],
  // Demo-hosted only (no embed anywhere) → all traffic is demo by definition.
  // ⚠️ At go-live the switch is a DIRECT DB WRITE to clients.production_origins (+
  // allowed_origins), NOT an edit here — the runtime reads config from Supabase and only
  // falls back to this file if the DB is unreachable. See "Runbook: Set Up a New Client"
  // step 8. (A brand-new client is different: provision-client.ts DOES carry this file's
  // value into the DB at birth.)
  productionOrigins: [],
  hostingStrategy: 'demo',
  cart: { strategy: 'navigate' },

  // ── Meilisearch ──
  indexName: 'products_test_greek',
  embedderName: 'parousiasi-openai',
  locale: 'ell',

  // ── Feed ──
  feedUrl: 'https://www.parousiasi.gr/product_feed.xml',
  productLimit: 10000,
  feedFormat: 'custom_xml',

  // ── Dynamic Facet Fields ──
  facetFields: [
    {
      field: 'color',
      label: 'Χρώμα',
      xmlFilterKey: 'Χρώμα',
      isArray: true,
      skipStems: new Set(['καφε', 'κρεμ']),
    },
    {
      field: 'material',
      label: 'Υλικό',
      xmlFilterKey: 'Υλικό',
      isArray: true,
      skipStems: new Set(),
    },
    {
      field: 'subcategory',
      label: 'Υποκατηγορία',
      xmlFilterKey: 'Υποκατηγορία',
      isArray: true,
    },
  ],

  // ── Search Tuning (from lib/searchConfig.ts) ──
  search: {
    semanticRatio: 0.0,
    minScoreThreshold: 0.7,
    fallbackScoreThreshold: 0.80,
    maxResultsToFetch: 1000,
    maxResultsToReturn: 1000,
  },

  // ── Agent Search Tuning (from lib/agent/agentSearchConfig.ts) ──
  agentSearch: {
    minScoreThreshold: 0.8,
    layer4ScoreThreshold: 0.75,
    layer1: { limit: 100, matchingStrategy: 'last' },
    layer2: { maxCategories: 15, totalBudget: 80, minPerCategory: 12, matchingStrategy: 'last' },
    layer3: { limit: 20, maxKeywords: 5, minKeywordLength: 4, matchingStrategy: 'last' },
    layer4: { limit: 120, matchingStrategy: 'all' },
    discovery: { minTermLength: 4, matchingStrategy: 'last' },
    maxProductsToReturn: 200,
  },

  // ── Language (from crawl/route.ts + search/route.ts) ──
  language: {
    stopWords: [
      'ο', 'ι', 'το', 'τα', 'του', 'τις', 'τον',
      'κε', 'για', 'σε', 'με', 'απο', 'προς',
      'κατ', 'κατιτ',
    ],
    synonyms: {
      'τασακ': ['σταχτοδοχι'],
      'σταχτοδοχι': ['τασακ'],
      'ριχο': ['ριχι', 'ριχα', 'ριχες'],
      'ριχι': ['ριχο', 'ριχα', 'ριχες'],
      'ριχα': ['ριχο', 'ριχι', 'ριχες'],
      'ριχες': ['ριχο', 'ριχι', 'ριχα'],
    },
    queryStopWords: [
      'από', 'απο', 'με', 'για', 'σε', 'και', 'στο', 'στη', 'στα',
      'στον', 'στην', 'του', 'της', 'των', 'τον', 'την', 'τους', 'τις',
      'ο', 'η', 'το', 'οι', 'τα', 'ένα', 'ενα', 'μια', 'μία', 'ένας', 'ενας', 'προς',
    ],
    pricePatterns: {
      maxPrice: /(?:μέχρι|μεχρι|έως|εως|κάτω από|κατω απο|κατω|κάτω|up to|under|below)\s+(\d+(\.\d+)?)\s*(?:ευρω|ευρώ|€|euros?)/i,
      minPrice: /(?:πάνω από|πανω απο|πανω|πάνω|από|απο|over|above)\s+(\d+(\.\d+)?)\s*(?:ευρω|ευρώ|€|euros?)/i,
      range: /(?:από|απο|from)?\s*(\d+(?:\.\d+)?)\s*(?:-|–|έως|εως|μέχρι|μεχρι|to)\s*(\d+(?:\.\d+)?)\s*(?:ευρω|ευρώ|€|euros?)/i,
    },
    noisyPhrases: [
      /πλυντ[ηή]ρ[ιί](?:ο|ου|α|ων|ά|ού)?\s+πι[αά]τ[ωώ]ν/gi,
    ],
  },

  // ── Index Settings (from crawl/route.ts) ──
  indexSettings: {
    searchableAttributes: [
      'title', 'title_normalized',
      'brand',
      'category', 'category_normalized',
      'subcategory', 'subcategory_normalized',
      'id', 'model',
      'description_short', 'description_short_normalized',
    ],
    displayedAttributes: [
      'id', 'client_id', 'title', 'description', 'description_short',
      'category', 'brand', 'model', 'price', 'image_url', 'url',
      'color', 'material', 'subcategory',
    ],
    rankingRules: [
      'words', 'typo', 'proximity', 'attribute', 'sort', 'exactness',
    ],
    localizedAttributes: [
      {
        locales: ['ell'],
        attributePatterns: ['title', 'category', 'subcategory', 'description_short'],
      },
    ],
    documentTemplate: '{{doc.category}} {{doc.subcategory}} - {{doc.brand}} {{doc.title}}. {{doc.color}} {{doc.material}}. {{doc.description}}',
    faceting: {
      maxValuesPerFacet: 500,
      sortFacetValuesBy: { '*': 'count' as const },
    },
    // Pinned to Meilisearch's default (5/9) — which is what this index has
    // ACTUALLY been running all along. This block was never sent to the engine
    // until 2026-08-25 (see applyIndexSettings), so the 4/8 written here
    // had never taken effect. Wiring it up would have silently made this client
    // MORE typo-tolerant than it has ever been, untested. Pinning to 5/9 keeps
    // behaviour byte-identical. Tune it deliberately, with a measured battery,
    // the way syfak's 6/10 was — do not copy syfak's number blindly.
typoTolerance: {
      minWordSizeForTypos: { oneTypo: 5, twoTypos: 9 },
    },
  },

  // ── System Prompt ──
  systemPrompt: {
    categories: PRODUCT_CATEGORIES,
    productConcepts: PRODUCT_CONCEPTS,
    buildPrompt: buildParousiasiPrompt,
  },

  // ── UI Configuration ──
  ui: {
    brandColor: '#9A003A',
    brandColorHover: '#7D0030',
    scrollbarColor: '#9A003A',
    fontCssVariable: '--font-gotham-greek',
    backgroundImage: '/parousiasi-bg.jpg',
    categoriesToHide: new Set([
      'Catalogue ads products',
      'Αρχική',
      'Modern Classic by Pozzi Milano',
      'Quality Easy Living',
      'Design',
      'Spring 2025',
    ]),
    exampleQueries: [
      { emoji: '🥤', text: 'Δώρο για smoothie lover', description: 'Gift ideas' },
      { emoji: '☕', text: 'Τι χρειάζομαι για coffee station στο σπίτι', description: 'Coffee setup' },
      { emoji: '🏠', text: 'Δώρο για νέο σπίτι πάνω από 60 ευρώ', description: 'Housewarming' },
      { emoji: '🍷', text: 'Δώρο για λάτρη του κρασιού μέχρι 50 ευρώ', description: 'Wine lover gift' },
      { emoji: '🍝', text: 'Για να μαγειρέψω ζυμαρικά με σάλτσα', description: 'Pasta cooking' },
    ],
    topSearches: ['fresh & save', 'luxembourg', 'alessi', 'wmf', 'κουπες'],
    strings: {
      searchPlaceholder: [
        'Δείξε μου οικονομικές λύσεις για να οργανώσω την κουζίνα',
        'Δώρο για λάτρη του κρασιού μέχρι 50€',
        'Σετ μαχαιριών κουζίνας',
        'Ποτήρια κρασιού',
      ],
      brandLabel: 'Brand',
      filtersTitle: 'Φίλτρα',
      suggestedCategories: 'Προτεινόμενες Κατηγορίες',
      otherCategories: 'Άλλες Κατηγορίες',
      priceRange: 'Εύρος Τιμής',
      productsTitle: 'Προϊόντα',
      noResults: 'Δε βρέθηκαν προϊόντα',
      noResultsHint: 'Δοκιμάστε διαφορετικές λέξεις - κλειδιά ή πιο γενικούς όρους αναζήτησης',
      showLess: 'Λιγότερα',
      showMore: (n: number) => `+${n} ακόμα...`,
      popularProducts: 'Δημοφιλή Προϊόντα',
      searchingSuggestions: 'Αναζήτηση Προτάσεων',
      searchingProducts: 'Αναζήτηση προϊόντων...',
      addToCart: 'ΠΡΟΣΘΗΚΗ ΣΤΟ ΚΑΛΑΘΙ',
      topSearchesTitle: 'Top Αναζητήσεις',
      aiAssistantTitle: 'AI Βοηθός',
      aiAssistantGreeting: 'Πώς μπορώ να σε βοηθήσω; Ρώτησέ με για προϊόντα, δώρα ή οτιδήποτε χρειάζεσαι.',
    },
  },
};
